import type { GridProps } from "@op/puck-types";

const Grid = ({ children }: GridProps) => {
  return <div className="w-full grid gap-2 grid-cols-4">{children}</div>;
};

export default Grid;
